import { useEffect, useRef } from "react";
import { FaXmark } from "react-icons/fa6";
import "./TimedFlashPopup.css";

/** Tempo padrão do popup dinâmico (barra + auto-fecho). */
export const TIMED_FLASH_DEFAULT_MS = 3000;

/**
 * Popup de feedback com barra temporizadora.
 * Fecha ao fim de `durationMs` (padrão 3s), pelo botão X (se `showClose`) ou,
 * no modo ecrã completo, ao clicar no overlay.
 *
 * `contained`: sobrepõe e centra no ancestral com `position: relative`
 * (ex.: modal de formulário), sem fechar o ancestral por si.
 */
export function TimedFlashPopup({
  tone = "ok",
  durationMs = TIMED_FLASH_DEFAULT_MS,
  onDismiss,
  showClose = false,
  contained = false,
  children,
}) {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    const t = setTimeout(() => {
      onDismissRef.current?.();
    }, durationMs);
    return () => clearTimeout(t);
  }, [children, durationMs, tone]);

  if (children == null || children === "") return null;

  const dismiss = () => onDismissRef.current?.();

  return (
    <div
      className={
        contained
          ? "spm-timed-flash spm-timed-flash--contained"
          : "spm-timed-flash"
      }
      role="presentation"
      onClick={contained ? undefined : dismiss}
    >
      <div
        className={`spm-timed-flash__panel spm-timed-flash__panel--${tone}`}
        role={tone === "ok" ? "status" : "alert"}
        aria-live="polite"
        onClick={(e) => e.stopPropagation()}
      >
        {showClose ? (
          <button
            type="button"
            className="spm-timed-flash__close"
            aria-label="Fechar"
            onClick={dismiss}
          >
            <FaXmark aria-hidden />
          </button>
        ) : null}
        <div className="spm-timed-flash__body">{children}</div>
        <div className="spm-timed-flash__timer" aria-hidden>
          <div
            key={`${tone}:${String(children)}`}
            className="spm-timed-flash__timer-bar"
            style={{ animationDuration: `${durationMs}ms` }}
          />
        </div>
      </div>
    </div>
  );
}
